import { queryOptions } from '@tanstack/vue-query'
import { unref, type MaybeRef } from 'vue'
import { getGifById } from '../api/get-gif-by-id'

export const getGifQueryKey = (id: MaybeRef<string>) => ['gif', id] as const

export const getGifQueryOptions = (id: MaybeRef<string>) =>
  queryOptions({
    queryFn: () => getGifById(unref(id)),
    queryKey: getGifQueryKey(id),
    staleTime: 86_400_000,
    gcTime: 3_600_000,
  })
